import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/styles/global.scss'

// 应用入口文件：挂载 Vue 根实例、注册全局插件/样式、配置 Element-UI 主题

// 覆盖 Element UI 默认主题色 - 淡绿色
const style = document.createElement('style')
style.textContent = `
  .el-button--primary {
    background-color: #52c41a !important;
    border-color: #52c41a !important;
  }
  .el-button--primary:hover,
  .el-button--primary:focus {
    background-color: #73d13d !important;
    border-color: #73d13d !important;
  }
  .el-button--primary:active {
    background-color: #389e0d !important;
    border-color: #389e0d !important;
  }
  .el-button--success {
    background-color: #52c41a !important;
    border-color: #52c41a !important;
  }
  .el-link--primary {
    color: #52c41a !important;
  }
  .el-menu-item.is-active {
    color: #52c41a !important;
  }
  .el-submenu .el-menu-item.is-active {
    color: #52c41a !important;
  }
  .el-switch.is-checked .el-switch__core {
    background-color: #52c41a !important;
    border-color: #52c41a !important;
  }
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #52c41a !important;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #52c41a !important;
    border-color: #52c41a !important;
  }
  .el-radio__input.is-checked .el-radio__inner {
    background-color: #52c41a !important;
    border-color: #52c41a !important;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #52c41a !important;
  }
  .el-tag--primary {
    background-color: rgba(82, 196, 26, 0.1) !important;
    border-color: rgba(82, 196, 26, 0.2) !important;
    color: #52c41a !important;
  }
  .el-tag--success {
    background-color: rgba(82, 196, 26, 0.1) !important;
    border-color: rgba(82, 196, 26, 0.2) !important;
    color: #52c41a !important;
  }
  .el-tabs__item.is-active {
    color: #52c41a !important;
  }
  .el-tabs__active-bar {
    background-color: #52c41a !important;
  }
  .el-input__inner:focus {
    border-color: #52c41a !important;
  }
  .el-select .el-input.is-focus .el-input__inner {
    border-color: #52c41a !important;
  }
  .el-form-item__label {
    color: #606266 !important;
  }
  .el-date-editor .el-input__inner:focus {
    border-color: #52c41a !important;
  }
  .el-pagination button:hover {
    color: #52c41a !important;
  }
  .el-pager li:hover {
    color: #52c41a !important;
  }
`
document.head.appendChild(style)

// 全局注册 Element-UI 组件库（全量引入，配合上方主题色覆盖样式）
Vue.use(ElementUI)
// 关闭生产环境启动时的 Vue 开发者提示
Vue.config.productionTip = false

// 创建 Vue 根实例：注入 router 与 store，渲染 App 组件并挂载到 #app
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
